import * as React from "react";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";

import { DeviceFraudStatusIcon } from "app/components/AppComponents/Fraud";

import { DatePicker, Dialog, MenuItem, SelectField } from "material-ui";

import * as moment from "moment-timezone";

import * as $ from "jquery";

import oktaClient from "app/utils/oktaClient";

import { susWithdrawalsList } from "./Fraud.SusWithdrawalsList.Query";

const historyName = "ss_fraud_sus_withdrawals";

class SuspiciousWithdrawals extends React.Component<any, any> {
  refSetHeight = undefined;

  constructor(props: any) {
    super(props);

    this.refSetHeight = React.createRef();

    // SETS DEAULT TO PREVIOUS DAY
    const filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);
    // TO USE SET filterDate: filterDate IN STATE

    this.state = {
      data: null,
      loading: false,
      limit: 30,
      offset: 0,
      filterDate: this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].filterDate
        : filterDate,
      selectedRows: [],
      shiftKey: false,
      lastItem: null,
      open: false,
      logData: "",
    };
  }

  componentDidMount() {
    const thiss = this;
    this.refSetHeight.current.addEventListener("scroll", function () {
      var translate =
        "translate(0," + thiss.refSetHeight.current.scrollTop + "px)";
      thiss.refSetHeight.current.querySelector(
        "thead"
      ).style.transform = translate;
    });
    $(document).on("keyup keydown", function (e: any) {
      thiss.setState({ shiftKey: e.shiftKey });
    });
    this.loadData(
      this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].filterDate
        : this.state.filterDate,
      this.props.savedStates[historyName]
        ? this.props.savedStates[historyName].offset
        : this.state.offset
    );
    this.props.setHeader({
      title: "Fraud > Suspicious Withdrawals",
      description: "Suspicious wallet withdrawals",
    });
  }

  componentWillUnmount() {
    $(document).off("keyup keydown");
  }

  loadData = (getFilter: any, getOffset: any) => {
    this.props.addToStates("ss_fraud_sus_withdrawals", {
      filterDate: getFilter,
      offset: getOffset,
    });
    this.setState({
      loading: true,
      data: null,
      filterDate: getFilter,
      offset: getOffset,
    });
    let createdAtFrom = null;
    let createdAtTo = null;

    if (getFilter !== null) {
      const setDateFrom = moment(getFilter)
        .startOf("day")
        .tz("Africa/Johannesburg")
        .format();
      const setDateTo = moment(getFilter)
        .endOf("day")
        .tz("Africa/Johannesburg")
        .format();
      createdAtFrom = setDateFrom;
      createdAtTo = setDateTo;
    }

    this.props.data.fetchMore({
      variables: {
        from: createdAtFrom,
        to: createdAtTo,
        offset: getOffset,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.fraud, loading: false });
      },
    });
  };

  loadNext = () => {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadData(this.state.filterDate, TMP_OFFSET);
  };

  loadPrev = () => {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadData(this.state.filterDate, TMP_OFFSET);
  };

  closeModal = () => {
    this.setState({ open: false, logData: "" });
  };

  openModal = (data: any) => {
    this.setState({ open: true, logData: data });
  };

  changeDate(event: any, date: any) {
    this.loadData(date, 0);
  }

  handleGroupStatus = (e: any, key: any, status: any) => {
    var token = oktaClient.getToken();
    const comment = "Updated by " + token.claims.email;
    var data = [];
    this.state.data.users_with_suspicious_withdrawals.map((item, i) => {
      return this.state.selectedRows.map((value, keyRow) => {
        if (parseInt(value, 10) === i) {
          var temp = [];
          temp["external_ref"] = item.devices[0].external_reference;
          temp["comment"] = comment;
          temp["status"] = status;

          data.push(temp);
        }
        return "1";
      });
    });
    this.runUpdate(data, this.state);
  };

  runUpdate = (data: any, state: any) => {
    const thiss = this;
    data.map((value, key) => {
      $.ajax({
        type: "POST",
        url:
          process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
          "/integration/console/fraud/device/fraud_status",
        data: {
          external_reference: value["external_ref"],
          comment: value["comment"],
          status: value["status"],
        },
        headers: {
          Authorization: oktaClient.getAuthorizationHeader(),
          "x-User-Groups": ["snapscan", "wechat", "masterpass"],
        },
      }).done(function () {
        thiss.loadData(state.filterDate, state.offset);
        thiss.setState({ selectedRows: [] });
      });
      return "1";
    });
  };

  checkRows = () => {
    const tmpArr = [];
    $(".itemSelect").map(function (key: any, val: any) {
      if ($(val).is(":checked")) {
        tmpArr.push(val.value);
      }

      return "1";
    });
    this.setState({ selectedRows: tmpArr });
  };

  toggleAll = (e: any) => {
    if ($(e.target).is(":checked")) {
      $(".itemSelect").prop("checked", true);
    } else {
      $(".itemSelect").prop("checked", false);
    }
    this.checkRows();
  };

  selectRow = (e: any) => {
    const value = $(e.target).val();
    if (this.state.shiftKey) {
      if (this.state.selectedRows.length > 0) {
        const lastItem = this.state.lastItem;
        if (parseInt(value, 10) > parseInt(lastItem, 10)) {
          $(".itemSelect").map(function (key: any, val: any) {
            if (
              parseInt($(val).val(), 10) > parseInt(lastItem, 10) &&
              parseInt($(val).val(), 10) < parseInt(value, 10)
            ) {
              $(val).prop("checked", true);
            }

            return "1";
          });
        } else {
          $(".itemSelect").map(function (key: any, val: any) {
            if (
              parseInt($(val).val(), 10) < parseInt(lastItem, 10) &&
              parseInt($(val).val(), 10) > parseInt(value, 10)
            ) {
              $(val).prop("checked", true);
            }

            return "1";
          });
        }
      } else {
        this.setState({ lastItem: value });
      }
    } else {
      this.setState({ lastItem: value });
    }
    this.checkRows();
  };

  render() {
    const topDevicesList = this.state.data
      ? this.state.data.users_with_suspicious_withdrawals
      : [];

    const renderDevices = (allDevices) => {
      const count = Object.keys(allDevices).length;
      return (
        <div>
          {count} - <DeviceFraudStatusIcon device={allDevices[0]} />
        </div>
      );
    };

    const renderUser = (user) => {
      return (
        <div key={user.external_reference}>
          <Link
            className="blueLink"
            to={`/snapscan/ops/users/${user.external_reference}/payments`}
          >
            {" "}
            {user.email}{" "}
          </Link>
          <a
            style={{ marginLeft: "6px" }}
            target="_blank"
            rel="noopener noreferrer"
            className="blueLink"
            href={user.snapmin_url}
          >
            <i className="fa fa-info-circle" />
          </a>
        </div>
      );
    };

    const showData = () => {
      if (topDevicesList.length > 0) {
        return topDevicesList.map((item, i) => {
          return (
            <tr style={{ height: "30px" }} key={i}>
              <td>
                <input
                  type="checkbox"
                  value={i}
                  className="itemSelect"
                  onClick={this.selectRow}
                />
              </td>
              <td
                style={{
                  height: "30px",
                  whiteSpace: "normal",
                  textAlign: "center",
                }}
              >
                {renderDevices(item.user.devices)}
              </td>
              <td style={{ height: "30px", whiteSpace: "normal" }}>
                {renderUser(item.user)}
              </td>

              <td style={{ textAlign: "right" }}>
                {item.total_friend_connection_count}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.total_onsend_amount_for_user / 100).toFixed(2)}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.total_topup_amount_for_user / 100).toFixed(2)}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.total_p2p_amount_for_user / 100).toFixed(2)}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.total_withdrawal_amount_for_user / 100).toFixed(2)}{" "}
              </td>
            </tr>
          );
        });
      }
    };

    const modalLog = (Comments) => {
      const convertedData = () => {
        if (Comments) {
          return Comments.map((comment, k) => {
            return <div key={k}>{comment}</div>;
          });
        } else {
          return null;
        }
      };
      return (
        <pre
          style={{
            outline: "1px solid #ccc",
            padding: "5px",
            margin: "5px",
            whiteSpace: "pre-wrap",
          }}
        >
          {convertedData()}
        </pre>
      );
    };

    return (
      <section id="Fraud_LimitHits" className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <DatePicker
            hintText="Date of"
            floatingLabelText="Date of"
            onChange={(e, date) => this.changeDate(e, date)}
            defaultDate={this.state.filterDate}
            style={{
              width: "200px",
              marginRight: "10px",
            }}
            textFieldStyle={{
              width: "200px",
            }}
          />
          <SelectField
            hintText="Status"
            value={null}
            onChange={this.handleGroupStatus}
            className={` ${
              this.state.selectedRows.length > 0 ? "shown" : "hidden"
            } `}
          >
            <MenuItem value={"monitored"} primaryText="Monitored" />
            <MenuItem value={"whitelisted"} primaryText="Whitelisted" />
            <MenuItem value={"blacklisted"} primaryText="Blacklisted" />
          </SelectField>
        </div>

        <div
          className={`loader-container ${
            this.state.loading ? "shown" : "hidden"
          }`}
        >
          <i className={`fa fa-spinner fa-spin fa-3x fa-fw`} />
        </div>

        <div
          ref={this.refSetHeight}
          style={{ height: "calc(100% - 70px)", overflow: "auto" }}
        >
          <table
            style={{
              width: "100%",
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th style={{ paddingLeft: "2px" }}>
                  <input
                    type="checkbox"
                    className="itemSelectAll"
                    onClick={this.toggleAll}
                  />
                </th>
                <th style={{ textAlign: "center" }}>Devices</th>
                <th>Users</th>
                <th style={{ textAlign: "right" }}>Friend count</th>
                <th style={{ textAlign: "right" }}>Onsend amount</th>
                <th style={{ textAlign: "right" }}>Top-up amount</th>
                <th style={{ textAlign: "right" }}>P2P amount</th>
                <th style={{ textAlign: "right" }}>Withdrawal amount</th>
              </tr>
            </thead>
            <tbody className={`${this.state.loading ? "hidden" : "shown"} `}>
              {showData()}
            </tbody>
          </table>
        </div>

        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={this.loadPrev}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          style={{ margin: "5px", padding: "4px" }}
          className={
            topDevicesList.length < 30 || this.state.loading ? "hidden" : ""
          }
          onClick={this.loadNext}
        >
          <i className="fa fa-chevron-right" />
        </button>

        <Dialog
          title="Log"
          modal={false}
          open={this.state.open}
          onRequestClose={this.closeModal}
          actions={[
            <input
              type="button"
              className="button"
              value="Close"
              onClick={this.closeModal}
            />,
          ]}
          autoScrollBodyContent={true}
        >
          {modalLog(this.state.logData)}
        </Dialog>
      </section>
    );
  }
}

const suspiciousWithdrawalsWithGraphql = graphql(susWithdrawalsList, {
  options(props: any) {
    return {
      variables: {
        from: null,
        to: null,
        offset: 0,
        limit: 30,
      },
    };
  },
})(SuspiciousWithdrawals);
export default suspiciousWithdrawalsWithGraphql;
